export default __webpack_public_path__ + "static/banner-image-2d58296a9c2b1e2d2e8b01fc771258ef.jpg";